import type { I18nContext } from '~lexibird-marketing/types/i18n-context';

/**
 * Client-only: the locale and catalogue ~lexibird-marketing/client loads before
 * hydrating. The client counterpart of ~lexibird-marketing/i18n-storage.
 */
export const i18nClientStore: { context?: I18nContext } = {};
